import type {TexVoronoiSockets} from "#material/nodes/texture/tex-voronoi/definition"
import type {MaterialNodeParameters, MaterialNodeSettings} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<TexVoronoiSockets>
type Previous = Omit<Current, "settings"> & {
    settings: Omit<MaterialNodeSettings<TexVoronoiSockets>, "feature"> & {feature?: MaterialNodeSettings<TexVoronoiSockets>["feature"] | "F4"}
}

/** Cycles has no F4 and never had, so a node asking for it has always rendered as its default, F1. */
export const renameF4ToF1: Version<Previous, Current> = {
    toNextVersion: ({settings = {}, ...parameters}) => ({
        ...parameters,
        settings: {...settings, feature: settings.feature === "F4" ? "F1" : settings.feature},
    }),
}
